import { forwardRef, type ButtonHTMLAttributes } from "react";

export const Button = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  loadingLabel?: string;
  variant?: "primary" | "secondary" | "quiet" | "destructive";
  size?: "standard" | "compact";
  appearance?: "default" | "dialog";
}>(function Button({
  children,
  className = "",
  loading = false,
  loadingLabel,
  type = "button",
  variant = "primary",
  appearance = "default",
  size = "standard",
  ...props
}, ref) {
  return (
    <button ref={ref} className={`${appearance === "dialog" ? variant === "quiet" ? "textbtn" : variant === "destructive" ? "textbtn danger" : variant === "primary" ? "btn primary" : "btn" : "button"} ${className}`.trim()} type={type} {...props} data-variant={variant} data-size={size} aria-label={loading && loadingLabel ? loadingLabel : props["aria-label"]} aria-busy={loading || undefined} disabled={loading || props.disabled}>
      {loading ? <span className="button-spinner" aria-hidden="true" /> : null}
      <span className={loading && loadingLabel ? "sr-only" : undefined}>{children}</span>
    </button>
  );
});
